export const environment = {
    production: false,
    base_url: '',
};
